<div class="container">
  <mat-form-field>
    <mat-chip-listbox #membersList aria-label="Manage team members (changes are saved immediately)">
      <mat-chip-option *ngFor="let member of cell.newValue" (removed)="remove(member)">
        {{ member.UserId }}
        &nbsp;<a><i matChipRemove class="ion-ios-close"></i></a>
      </mat-chip-option>
      <input
        placeholder="Manage team members (changes are saved immediately)"
        [matChipInputFor]="membersList"
        [matChipInputSeparatorKeyCodes]="SeparatorKeyCodes"
        (matChipInputTokenEnd)="add($event)" />
    </mat-chip-listbox>
  </mat-form-field>
</div>
